module.exports = __webpack_public_path__ + "img/photo2.jpg.d1f9fd42.webp";